import React from 'react';
import { cn } from '@/lib/utils';

interface ConfigCardProps {
  title: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
}

export default function ConfigCard({
  title,
  description,
  children,
  className,
}: ConfigCardProps) {
  return (
    <section className={cn('rounded-xl border border-border bg-card p-5 shadow-none', className)}>
      <h3 className="text-[15px] font-medium text-foreground">{title}</h3>
      {description && (
        <p className="mt-1 text-[13px] leading-5 text-muted-foreground">{description}</p>
      )}
      <div className="mt-4">
        {children}
      </div>
    </section>
  );
}

